<template >
  <div id="loader">
    <div class="outer-circle" :style="setCssVariables">
      <div :style="setCssVariables" class="circle inner-circle1"></div>
      <div :style="setCssVariables" class="circle inner-circle2"></div>
      <div :style="setCssVariables" class="circle inner-circle3"></div>
      <div :style="setCssVariables" class="circle inner-circle4"></div>
      <div :style="setCssVariables" class="circle inner-circle5"></div>
      <div :style="setCssVariables" class="circle inner-circle6"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      innerCircleSize: 10,
      outerCircleSize: 80,
      time: 3,
      scale1: 4,
      scale2: .1,
      radius1: 25,
      radius2: 0,
      opacity1: .05,
      opacity2: 1
    }
  },
  computed: {
    setCssVariables () {
      return {
        "--innerCircleSize": this.innerCircleSize + "px",
        "--scale1": this.scale1,
        "--scale2": this.scale2 + "",
        "--opacity1": this.opacity1,
        "--opacity2": this.opacity2,
        "--radius1": this.radius1 + "px",
        "--radius2": this.radius2 + "px",
        "--time": this.time + "s",
        "--outerCircleSize": this.outerCircleSize + "px",
        "--offset": (this.outerCircleSize / 2 - this.innerCircleSize / 2) + "px"
      }
    }
  }
}

</script>

<style>
.outer-circle {
  /* background-color: white; */
  height: var(--outerCircleSize);
  width: var(--outerCircleSize);
  position: relative;
  border-radius: 50%;
}
.circle {
  height: var(--innerCircleSize);
  width: var(--innerCircleSize);
  left: var(--offset);
  top: var(--offset);
  position: absolute;
  border-radius: 50%;
}
.inner-circle1 {
  background-color: rgb(0, 255, 0);
  animation: myOrbit1 var(--time) linear infinite;
}
.inner-circle2 {
  background-color: rgb(0, 0, 255);
  animation: myOrbit2 var(--time) linear infinite;
}
.inner-circle3 {
  background-color: rgb(255, 0, 0);
  animation: myOrbit3 var(--time) linear infinite;
}
.inner-circle4 {
  background-color: rgb(0, 255, 255);
  animation: myOrbit4 var(--time) linear infinite;
}
.inner-circle5 {
  background-color: rgb(255, 255, 0);
  animation: myOrbit5 var(--time) linear infinite;
}
.inner-circle6 {
  background-color: rgb(255, 0, 255);
  animation: myOrbit6 var(--time) linear infinite;
}

@keyframes myOrbit1 {
  from {
    transform: rotate(0deg) translateX(var(--radius1, 0)) rotate(0deg);
    opacity: var(--opacity2);
  }
  50% {
    transform: rotate(360deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
  }
  to {
    transform: rotate(720deg) translateX(var(--radius1, 0)) rotate(0deg);
    opacity: var(--opacity2);
    filter: blur(1px);
  }
}

@keyframes myOrbit2 {
  from {
    transform: rotate(-120deg) translateX(var(--radius1, 0));
    opacity: var(--opacity2);
  }
  50% {
    transform: rotate(240deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
  }
  to {
    transform: rotate(600deg) translateX(var(--radius1, 0));
    opacity: var(--opacity2);
    filter: blur(1px);
  }
}

@keyframes myOrbit3 {
  from {
    transform: rotate(120deg) translateX(var(--radius1, 0)) rotate(0deg);
    opacity: var(--opacity2);
  }
  50% {
    transform: rotate(480deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
  }
  to {
    transform: rotate(840deg) translateX(var(--radius1, 0)) rotate(0deg);
    opacity: var(--opacity2);
    filter: blur(1px);
  }
}
@keyframes myOrbit4 {
  from {
    transform: rotate(60deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
  }
  50% {
    transform: rotate(420deg) translateX(var(--radius1, 0)) rotate(0deg)
      scale(var(--scale2));
    opacity: var(--opacity2);
  }
  to {
    transform: rotate(780deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
    filter: blur(1px);
  }
}

@keyframes myOrbit5 {
  from {
    transform: rotate(-60deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
  }
  50% {
    transform: rotate(300deg) translateX(var(--radius1, 0)) rotate(0deg)
      scale(var(--scale2));
    opacity: var(--opacity2);
  }
  to {
    transform: rotate(660deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
    filter: blur(1px);
  }
}

@keyframes myOrbit6 {
  from {
    transform: rotate(180deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
  }
  50% {
    transform: rotate(540deg) translateX(var(--radius1, 0)) rotate(0deg)
      scale(var(--scale2));
    opacity: var(--opacity2);
  }
  to {
    transform: rotate(900deg) translateX(var(--radius2, 0)) rotate(0deg)
      scale(var(--scale1));
    opacity: var(--opacity1);
    filter: blur(1px);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Loader.vue